module.exports = __webpack_public_path__ + "fonts/Nunito-700-cyrillic17.0661baa.woff2";